import { render, staticRenderFns } from "./EnrollmentAcknowledgement.vue?vue&type=template&id=687269e0&scoped=true"
import script from "./EnrollmentAcknowledgement.vue?vue&type=script&lang=js"
export * from "./EnrollmentAcknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687269e0",
  null
  
)

export default component.exports